import { IsInt } from 'class-validator';

export class NomenclatureTypeChildDeleteRequest {
    @IsInt()
    public id: number;

    constructor(data?: Partial<NomenclatureTypeChildDeleteRequest>) {
        this.id = data?.id;
    }
}
